<template>
    <div>
        <status-bloqueio :bloqueado="contrato.bloqueado"></status-bloqueio>

        <form class="form-horizontal">

            <div class="form-group">

                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>

                <div class="col-sm-12">
                    <label class="control-label">EMAIL DO CLIENTE</label>
                    <input disabled type="text" v-model="cliente.email" class="form-control" >
                </div>

            </div>

            <div class="form-group">
                <div class="col-sm-12">
                    <novo-boleto :contrato_id="contrato._id"></novo-boleto>
                </div>
            </div>

        </form>

    </div>
</template>
<script>
import { Contratos } from "../../../class/index";
import {
    StatusBloqueio,
    ContratoMenu,
    NovoBoleto
} from "../../../components/exports";
import ComboConcentrador from "../../../components/contratos/ComboConcentrador.vue";
import contratoMixin from "../../mixins/contrato";

export default {
    components: {
        ContratoMenu,
        StatusBloqueio,
        NovoBoleto,
        ComboConcentrador
    },
    mixins: [contratoMixin],
    data() {
        return {};
    },
    methods: {
        save() {
            Contratos.save(this.contrato)
                .then(() => {
                    this.$router.push({ path: "/contratos" });
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
